import { instance } from "config/axiosInstance";

// note: declare base url
const baseURL = process.env.REACT_APP_TENANT_BE;

export async function getMitra(pathname, queryParams = "", extraHeaders = {}) {
  return await instance({ baseURL: baseURL }).get(pathname + queryParams, {
    headers: extraHeaders,
  });
}

export async function createMitra(pathname, body) {
  return await instance({
    baseURL: baseURL,
  }).post("/mitra" + pathname, body);
}

export async function updateMitra(pathname, body) {
  return await instance({
    baseURL: baseURL,
  }).patch("/mitra" + pathname, body);
}

export async function deleteMitra(pathname, body) {
  return await instance({
    baseURL: baseURL,
  }).delete("/mitra" + pathname, { data: body });
}

export async function bulkCreateMitra(mitras) {
  return await instance({
    baseURL: baseURL,
  }).post("/mitra/bulk", { mitras });
}
